<script setup lang="ts">
import { computed, inject, ref } from 'vue'
import { PanelLeftClose, PanelLeftOpen } from '@lucide/vue'
import { SIDEBAR_COLLAPSED } from './const'
import SidebarItem from './SidebarItem.vue'

const emit = defineEmits<{
  (e: 'toggle'): void
}>()

const collapsed = inject(SIDEBAR_COLLAPSED, ref(false))

const icon = computed(() => collapsed.value ? PanelLeftOpen : PanelLeftClose)
const label = computed(() => collapsed.value ? 'Expand sidebar' : 'Collapse')
</script>

<template>
  <SidebarItem
    :icon
    :label
    @click="emit('toggle')"
  />
</template>
